"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
interface SummaryProps {
  summary?: string;
  title?: string;
}
const MAX_LENGTH = 350;
const SummaryComponent = t0 => {
  const $ = _c(13);
  const {
    summary,
    title
  } = t0;
  const [expanded, setExpanded] = useState(false);
  if (!summary) {
    return null;
  }
  const isLong = summary.length > MAX_LENGTH;
  const text = !isLong || expanded ? summary : summary.slice(0, MAX_LENGTH) + "...";
  let t1;
  if ($[0] !== title) {
    t1 = <div className="w-100 flex flex-col items-start mt-6 lg:mt-0 "><div className="w-100 flex items-center mb-3 md:mb-6"><h3 className="text-white text-md md:text-2xl font-extrabold">داستان {title}</h3></div></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <p className="block mt-2 text-sm md:text-md text-white font-bold leading-7 max-w-[850px]">{text}</p>;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== expanded || $[5] !== isLong) {
    t3 = isLong && <button type="button" onClick={() => setExpanded(_temp)} aria-expanded={expanded} className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 hover:bg-primary/20 text-primary text-xs md:text-sm font-bold px-3 py-1.5 transition-colors cursor-pointer">{expanded ? "\u0646\u0645\u0627\u06CC\u0634 \u06A9\u0645\u062A\u0631" : "\u0645\u0634\u0627\u0647\u062F\u0647 \u0628\u06CC\u0634\u062A\u0631"}<ChevronDown size={16} className={`transition-transform duration-200 ${expanded ? "rotate-180" : ""}`} /></button>;
    $[4] = expanded;
    $[5] = isLong;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="space-y-3 mb-4 md:mb-12">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default SummaryComponent;
function _temp(v) {
  return !v;
}